import { render, staticRenderFns } from "./system-admin.vue?vue&type=template&id=04aebf67&scoped=true"
import script from "./system-admin.vue?vue&type=script&lang=js"
export * from "./system-admin.vue?vue&type=script&lang=js"
import style0 from "./system-admin.vue?vue&type=style&index=0&id=04aebf67&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aebf67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04aebf67')) {
      api.createRecord('04aebf67', component.options)
    } else {
      api.reload('04aebf67', component.options)
    }
    module.hot.accept("./system-admin.vue?vue&type=template&id=04aebf67&scoped=true", function () {
      api.rerender('04aebf67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/system-admin.vue"
export default component.exports